import { render, staticRenderFns } from "./noticeArea.vue?vue&type=template&id=3b1b77f6&scoped=true"
import script from "./noticeArea.vue?vue&type=script&lang=js"
export * from "./noticeArea.vue?vue&type=script&lang=js"
import style0 from "./noticeArea.vue?vue&type=style&index=0&id=3b1b77f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1b77f6",
  null
  
)

export default component.exports